import { render, staticRenderFns } from "./TenantCustomer.vue?vue&type=template&id=149d132e"
import script from "./TenantCustomer.vue?vue&type=script&lang=js"
export * from "./TenantCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports